import React, { Component } from "react";

export default class MessageComponent extends Component {
  render() {
    const { type, message } = this.props;
    return (
      <div
        className="messageInfo"
        style={{ color: type === "e" ? "red" : "black" }}
      >
        {message}
      </div>
    );
  }
}
